import React, { createContext, useContext } from 'react';

// COSS kbd. A key cap, not a control: nothing to press. The cap is inline
// content, 20px default and 16px compact, so it can sit inside a bounded
// control. A group is several caps for one shortcut.

const SizeContext = createContext('default');

export function KbdGroup({ size = 'default', className, children, ...props }) {
  return (
    <kbd {...props} className={['edl-kbd-group', className].filter(Boolean).join(' ')} data-size={size}>
      <SizeContext.Provider value={size}>{children}</SizeContext.Provider>
    </kbd>
  );
}

export function Kbd({ size, className, ...props }) {
  const inherited = useContext(SizeContext);
  return (
    <kbd
      {...props}
      className={['edl-kbd', className].filter(Boolean).join(' ')}
      data-size={size ?? inherited}
    />
  );
}
